<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatterPage" id="fm01"><p class="txt"><span> </span></p><h3 class="c10">HISTORIAN'S NOTE</h3><br/><p class="txtno"><span><i>The Trojan Spaceship</i> takes place in the fourth season of STAR TREK: DEEP SPACE NINE.</span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780743420488_fm01.vue?064c7bbf